<template>
  <v-data-table
    ref="table"
    :headers="headers"
    :items="list"
    :no-data-text="'Нет данных для отображения'"
    :loading="isLoading"
    :items-per-page="itemsPerPage"
    :options.sync="dataTableOptions"
    class="elevation-0"
    hide-default-footer
  >
    <template v-if="$slots.toolbar" v-slot:top>
      <v-toolbar color="blue darken-3" dark flat>
        <slot name="toolbar" />
      </v-toolbar>
    </template>

    <template v-for="slot in slots" :slot="slot" slot-scope="{ item }">
      <slot :item="item" :name="slot" />
    </template>

    <template v-if="pagination" v-slot:footer>
      <v-pagination
        :length="pagination.lastPage"
        :total-visible="6"
        :value="pagination.currentPage"
        :disabled="pagination.lastPage === 1"
        color="blue darken-3"
        class="pb-4 pt-4"
        @input="$emit('change-page', $event)"
      />
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'data-table',
  props: {
    options: Object,
    reference: {
      type: String,
      default: () => 'data-table',
    },
    headers: {
      type: Array,
      default: () => ([]),
    },
    list: {
      type: Array,
      required: true,
    },
    pagination: Object,
    isLoading: Boolean,
    itemsPerPage: Number,
  },
  data: () => ({
    slots: [],
    dataTableOptions: {},
  }),
  watch: {
    dataTableOptions(opts) {
      this.$emit('update:options', opts);
    },
  },

  mounted() {
    this.dataTableOptions = { ...this.options };

    let parent = this.$parent;
    let found = false;

    // максимум 30 вложений
    for (let i = 0; i < 30; i += 1) {
      if (parent && parent.$refs[this.reference]) {
        this.slots = Object.keys(parent.$refs[this.reference].$scopedSlots);
        found = true;
        break;
      } else if (parent) {
        parent = parent.$parent;
      } else { break; }
    }

    this.slots = this.slots.filter(_ => !['toolbar'].includes(_));

    if (!found) {
      console.error('Check reference key of data-table. reference key and ref must be the same!');
    }
  },
};
</script>
